import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleAdsLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5753 9.1862L11.0081 5.39453L3.4248 18.2279L9.99197 22.0195L17.5753 9.1862Z",
			fill: "#FFC107"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5916 22.0215C19.6387 23.835 22.0024 24.4388 23.771 23.4092C25.5811 22.3557 26.2059 20.0434 25.1588 18.2298L17.5755 5.39646C16.5284 3.58288 14.1717 2.97913 12.396 4.00871C10.5842 5.0593 9.96121 7.37455 11.0083 9.18813L18.5916 22.0215Z",
			fill: "#1E88E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.70866 23.9154C8.80274 23.9154 10.5003 22.2178 10.5003 20.1237C10.5003 18.0296 8.80274 16.332 6.70866 16.332C4.61458 16.332 2.91699 18.0296 2.91699 20.1237C2.91699 22.2178 4.61458 23.9154 6.70866 23.9154Z",
			fill: "#43A047"
		})
	]
});
export default SvgGoogleAdsLogo;
